export default {
  en: {
    list: {
      title: "Rules",
      buttons: {
        import: "Import Rule List",
        new: "Input New Rule",
        importButton: "Import"
      },
      filters: {
        INPUT: "Input",
        IMPORTED: "Imported"
      },
      table: {
        origin_type: "Source",
        trait: "Variable",
        match: "Value",
        description: "Description",
        created_at: "Inclusion",
        abilities_using_rule: "Used by"
      }
    },
    modal: {
      remove: {
        title: "Remove Rule? | Remove Rules?",
        text: "Are you sure that you want to remove this rule from your database? | Are you sure that you want to remove these Rules from your database?"
      }
    },
    forms: {
      ruleName: "Rule Name",
      ruleNamePlaceholder: "Input the Rule name",
      ruleValue: "Value",
      ruleValuePlaceholder: "Input the Rule value",
      ruleDescription: "Description",
      ruleDescriptionPlaceholder:
        "Fill the description field to help identify the Rule"
    },
    form: {
      placeholderRulesImported: "Search by Rule"
    },
    details: {
      noAbilitiesTitle: "There are no abilities using this Rule",
      noAbilitiesDescription:
        "Try check the abilities list to find out which Rule you need to input"
    },
    import: {
      noRulesDetectedTitle: "No Rules detected",
      quantity:
        "No valid Rule found in the uploaded document | <b>{qtd}</b> Rule was found in the uploaded document | <b>{qtd}</b> Rules were found in the uploaded document"
    }
  },
  pt: {
    list: {
      title: "Regras",
      buttons: {
        import: "Importar Lista de Regras",
        new: "Inserir Nova Regra",
        importButton: "Importar"
      },
      filters: {
        INPUT: "Inserido",
        IMPORTED: "Importado"
      },
      table: {
        origin_type: "Fonte",
        trait: "Variável",
        match: "Valor",
        description: "Descrição",
        created_at: "Inclusão",
        abilities_using_rule: "Usado por"
      }
    },
    modal: {
      remove: {
        title: "Remover Regra? | Remover Regras?",
        text: "Tem certeza de que deseja remover essa Regra da sua base de dados? | Tem certeza de que deseja remover essas Regras da sua base de dados?"
      }
    },
    forms: {
      ruleName: "Nome da Regra",
      ruleNamePlaceholder: "Nome da Regra de entrada",
      ruleValue: "Valor",
      ruleValuePlaceholder: "Valor da Regra de entrada",
      ruleDescription: "Descrição",
      ruleDescriptionPlaceholder:
        "Preencha o campo de descrição para ajudar a identificar a Regra"
    },
    form: {
      placeholderRulesImported: "Buscar por Regra"
    },
    details: {
      noAbilitiesTitle: "Não há habilidades utilizando essa Regra",
      noAbilitiesDescription:
        "Tente verificar a lista de habilidades para descobrir qual Regra você precisa inserir"
    },
    import: {
      noRulesDetectedTitle: "Nenhuma Regra detectada",
      quantity:
        "Nenhuma Regra válida encontrada no documento carregado | <b>{qtd}</b> Regra foi encontrada no documento carregado | <b>{qtd}</b> Regras foram encontradas no documento carregado"
    }
  },
  es: {
    list: {
      title: "Reglas",
      buttons: {
        import: "Importar Lista de Reglas",
        new: "Insertar Nueva Regla",
        importButton: "Importar"
      },
      filters: {
        INPUT: "Insertado",
        IMPORTED: "Importado"
      },
      table: {
        origin_type: "Fuente",
        trait: "Variable",
        match: "Valor",
        description: "Descripción",
        created_at: "Inclusión",
        abilities_using_rule: "Utilizado por"
      }
    },
    modal: {
      remove: {
        title: "¿Quitar Regla? | ¿Quitar Reglas?",
        text: "¿Está seguro de que desea eliminar esta Regla de la base de datos? | ¿Está seguro de que desea eliminar estas Reglas de su base de datos?"
      }
    },
    forms: {
      ruleName: "Nombre de la Regla",
      ruleNamePlaceholder: "Ingrese el nombre de la Regla",
      ruleValue: "Valor",
      ruleValuePlaceholder: "Ingrese el valor de la Regla",
      ruleDescription: "Descripción",
      ruleDescriptionPlaceholder:
        "Complete el campo de descripción para ayudar a identificar la Regla"
    },
    form: {
      placeholderRulesImported: "Buscar por Regla"
    },
    details: {
      noAbilitiesTitle: "No hay habilidades usando esta Regla",
      noAbilitiesDescription:
        "Intente consultar la lista de habilidades para averiguar qué Regla necesita ingresar"
    },
    import: {
      noRulesDetectedTitle: "No se detectaron Reglas",
      quantity:
        "No se ha encontrado ninguna Regla válida en el documento cargado | Se ha encontrado <b>{qtd}</b> Regla en el documento subido | Se encontraron <b>{qtd}</b> Reglas en el documento subido"
    }
  }
}
